// Mapping of ISO 3166-1 alpha-3 to alpha-2 country codes for Semantic UI React flags
export const countryCodeMapping = {
    'afg': 'af', // Afghanistan
    'alb': 'al', // Albania
    'dza': 'dz', // Algeria
    'and': 'ad', // Andorra
    'ago': 'ao', // Angola
    'atg': 'ag', // Antigua and Barbuda
    'arg': 'ar', // Argentina
    'arm': 'am', // Armenia
    'aus': 'au', // Australia
    'aut': 'at', // Austria
    'aze': 'az', // Azerbaijan
    'bhs': 'bs', // Bahamas
    'bhr': 'bh', // Bahrain
    'bgd': 'bd', // Bangladesh
    'brb': 'bb', // Barbados
    'blr': 'by', // Belarus
    'bel': 'be', // Belgium
    'blz': 'bz', // Belize
    'ben': 'bj', // Benin
    'btn': 'bt', // Bhutan
    'bol': 'bo', // Bolivia
    'bih': 'ba', // Bosnia and Herzegovina
    'bwa': 'bw', // Botswana
    'bra': 'br', // Brazil
    'brn': 'bn', // Brunei
    'bgr': 'bg', // Bulgaria
    'bfa': 'bf', // Burkina Faso
    'bdi': 'bi', // Burundi
    'khm': 'kh', // Cambodia
    'cmr': 'cm', // Cameroon
    'can': 'ca', // Canada
    'cpv': 'cv', // Cape Verde
    'caf': 'cf', // Central African Republic
    'tcd': 'td', // Chad
    'chl': 'cl', // Chile
    'chn': 'cn', // China
    'col': 'co', // Colombia
    'com': 'km', // Comoros
    'cog': 'cg', // Congo
    'cod': 'cd', // Congo, Democratic Republic of the
    'cri': 'cr', // Costa Rica
    'civ': 'ci', // Côte d'Ivoire
    'hrv': 'hr', // Croatia
    'cub': 'cu', // Cuba
    'cyp': 'cy', // Cyprus
    'cze': 'cz', // Czech Republic
    'dnk': 'dk', // Denmark
    'dji': 'dj', // Djibouti
    'dom': 'do', // Dominican Republic
    'ecu': 'ec', // Ecuador
    'egy': 'eg', // Egypt
    'slv': 'sv', // El Salvador
    'gnq': 'gq', // Equatorial Guinea
    'eri': 'er', // Eritrea
    'est': 'ee', // Estonia
    'eth': 'et', // Ethiopia
    'fji': 'fj', // Fiji
    'fin': 'fi', // Finland
    'fra': 'fr', // France
    'gab': 'ga', // Gabon
    'gmb': 'gm', // Gambia
    'geo': 'ge', // Georgia
    'deu': 'de', // Germany
    'gha': 'gh', // Ghana
    'grc': 'gr', // Greece
    'grd': 'gd', // Grenada
    'gtm': 'gt', // Guatemala
    'gin': 'gn', // Guinea
    'gnb': 'gw', // Guinea-Bissau
    'guy': 'gy', // Guyana
    'hti': 'ht', // Haiti
    'hnd': 'hn', // Honduras
    'hun': 'hu', // Hungary
    'isl': 'is', // Iceland
    'ind': 'in', // India
    'idn': 'id', // Indonesia
    'irn': 'ir', // Iran
    'irq': 'iq', // Iraq
    'irl': 'ie', // Ireland
    'isr': 'il', // Israel
    'ita': 'it', // Italy
    'jam': 'jm', // Jamaica
    'jpn': 'jp', // Japan
    'jor': 'jo', // Jordan
    'kaz': 'kz', // Kazakhstan
    'ken': 'ke', // Kenya
    'kir': 'ki', // Kiribati
    'kwt': 'kw', // Kuwait
    'kgz': 'kg', // Kyrgyzstan
    'lao': 'la', // Laos
    'lva': 'lv', // Latvia
    'lbn': 'lb', // Lebanon
    'lso': 'ls', // Lesotho
    'lbr': 'lr', // Liberia
    'lby': 'ly', // Libya
    'lie': 'li', // Liechtenstein
    'ltu': 'lt', // Lithuania
    'lux': 'lu', // Luxembourg
    'mkd': 'mk', // North Macedonia
    'mdg': 'mg', // Madagascar
    'mwi': 'mw', // Malawi
    'mys': 'my', // Malaysia
    'mdv': 'mv', // Maldives
    'mli': 'ml', // Mali
    'mlt': 'mt', // Malta
    'mhl': 'mh', // Marshall Islands
    'mrt': 'mr', // Mauritania
    'mus': 'mu', // Mauritius
    'mex': 'mx', // Mexico
    'fsm': 'fm', // Micronesia
    'mda': 'md', // Moldova
    'mco': 'mc', // Monaco
    'mng': 'mn', // Mongolia
    'mne': 'me', // Montenegro
    'mar': 'ma', // Morocco
    'moz': 'mz', // Mozambique
    'mmr': 'mm', // Myanmar
    'nam': 'na', // Namibia
    'nru': 'nr', // Nauru
    'npl': 'np', // Nepal
    'nld': 'nl', // Netherlands
    'nzl': 'nz', // New Zealand
    'nic': 'ni', // Nicaragua
    'ner': 'ne', // Niger
    'nga': 'ng', // Nigeria
    'nor': 'no', // Norway
    'omn': 'om', // Oman
    'pak': 'pk', // Pakistan
    'plw': 'pw', // Palau
    'pan': 'pa', // Panama
    'png': 'pg', // Papua New Guinea
    'pry': 'py', // Paraguay
    'per': 'pe', // Peru
    'phl': 'ph', // Philippines
    'pol': 'pl', // Poland
    'prt': 'pt', // Portugal
    'qat': 'qa', // Qatar
    'rou': 'ro', // Romania
    'rus': 'ru', // Russia
    'rwa': 'rw', // Rwanda
    'kna': 'kn', // Saint Kitts and Nevis
    'lca': 'lc', // Saint Lucia
    'vct': 'vc', // Saint Vincent and the Grenadines
    'wsm': 'ws', // Samoa
    'smr': 'sm', // San Marino
    'stp': 'st', // Sao Tome and Principe
    'sau': 'sa', // Saudi Arabia
    'sen': 'sn', // Senegal
    'srb': 'rs', // Serbia
    'syc': 'sc', // Seychelles
    'sle': 'sl', // Sierra Leone
    'sgp': 'sg', // Singapore
    'svk': 'sk', // Slovakia
    'svn': 'si', // Slovenia
    'slb': 'sb', // Solomon Islands
    'som': 'so', // Somalia
    'zaf': 'za', // South Africa
    'ssd': 'ss', // South Sudan
    'esp': 'es', // Spain
    'lka': 'lk', // Sri Lanka
    'sdn': 'sd', // Sudan
    'sur': 'sr', // Suriname
    'swz': 'sz', // Eswatini
    'swe': 'se', // Sweden
    'che': 'ch', // Switzerland
    'syr': 'sy', // Syria
    'twn': 'tw', // Taiwan
    'tjk': 'tj', // Tajikistan
    'tza': 'tz', // Tanzania
    'tha': 'th', // Thailand
    'tls': 'tl', // Timor-Leste
    'tgo': 'tg', // Togo
    'ton': 'to', // Tonga
    'tto': 'tt', // Trinidad and Tobago
    'tun': 'tn', // Tunisia
    'tur': 'tr', // Turkey
    'tkm': 'tm', // Turkmenistan
    'tuv': 'tv', // Tuvalu
    'uga': 'ug', // Uganda
    'ukr': 'ua', // Ukraine
    'are': 'ae', // United Arab Emirates
    'gbr': 'gb', // United Kingdom
    'usa': 'us', // United States
    'ury': 'uy', // Uruguay
    'uzb': 'uz', // Uzbekistan
    'vut': 'vu', // Vanuatu
    'ven': 've', // Venezuela
      'vnm': 'vn', // Vietnam
  'wlf': 'wf', // Wallis and Futuna
  'esh': 'eh', // Western Sahara
  'yem': 'ye', // Yemen
  'zmb': 'zm', // Zambia
  'zwe': 'zw', // Zimbabwe
};

// Function to convert 3-letter country code to 2-letter code
export const convertToAlpha2 = (alpha3Code) => {
    if (!alpha3Code) return null;
    const lowerCode = alpha3Code.toLowerCase();
    return countryCodeMapping[lowerCode] || null;
}; 